import { SseEventBase } from './sse-event-base.model';
import { SseEventType } from './sse-event-type.model';
import { runInInjectionContext } from '@angular/core';
import { NotificationReasonEnum } from '../../enums/notification/notification-reason.enum';

export class SseJobEvent extends SseEventBase {

  type: SseEventType = 'job';
  onMessage = (event: MessageEvent<any>): void => {
    const resp = JSON.parse(event.data);

    if (this.hasEvents(resp)) {
      runInInjectionContext(this.injector, () => {
        resp.events.forEach(event => this.onEvent(resp, event));
      });
    }
  }

  private onEvent(resp: any, event: NotificationReasonEnum): void {
    this.ngZone.run(() => {
      switch (event) {
        case NotificationReasonEnum.JOB_UPDATED: {
          setTimeout(() => {
            this.on.sseJobUpdated$.next(resp.jobId);
          }, 500);
          break;
        }
        case NotificationReasonEnum.JOB_LOCK_CHANGED: {
          this.on.sseJobUpdated$.next(resp.jobId);
          break;
        }
        case NotificationReasonEnum.CHECKLIST_LOCK_CHANGED: {
          this.on.sseChecklistLockChanged$.next({
            checklistId: resp.checklistId,
            checklistRevisionId: resp.checklistRevisionId
          });
          break;
        }
        case NotificationReasonEnum.JOB_ASSIGNED_TO_ME:
        case NotificationReasonEnum.JOB_CREATED_BY_ME:
        case NotificationReasonEnum.CHAT_ENTRY_CREATED: {
          this.on.chatEntryCrated$.next({ chatId: resp.chatId, chatEntryId: resp.chatEntryId });
          break;
        }
      }
    });
  }
}
